import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit, OnDestroy {
  @Input() eventDate: number; // Accept the event date as an input property
  private subscription: Subscription;
  
  public days: number;
  public hours: number;
  public minutes: number;
  public seconds: number;

  ngOnInit() {
    if (!this.eventDate || !moment(this.eventDate).isValid()) {
      console.error('Invalid event date provided');
      return;
    }

    this.updateTime();

    this.subscription = interval(1000).subscribe(() => {
      this.updateTime();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private updateTime() {
    const eventMoment = moment(this.eventDate);
    const now = moment();
    const duration = moment.duration(eventMoment.diff(now));

    if (duration.asMilliseconds() <= 0) {
      // Event date has passed
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
    } else {
      this.days = duration.days();
      this.hours = duration.hours();
      this.minutes = duration.minutes();
      this.seconds = duration.seconds();
    }
  }
}